import { useMemo } from 'react';
import { useActiveDay } from '../useActiveDay';
import { useActiveMonth } from '../useActiveMonth';
import { DateRange } from '../../services';

export const useActiveRange = (precision: 'day' | 'month') => {
    const activeDay = useActiveDay();
    const activeMonth = useActiveMonth();

    const activeRange: DateRange = useMemo(() => {
        switch (precision) {
            case 'day':
                return activeDay.range;
            case 'month':
                return activeMonth.range;
        }
    }, [precision, activeDay, activeMonth]);

    return activeRange;
};
